import { Injectable } from '@angular/core';
import { Language } from '@vendasta/atlas/core';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { AtlasApiService } from './atlas_sdk/atlas.api.service';

@Injectable({providedIn: 'root'})
export class AtlasLanguageLoader {
  readonly english$: Observable<any>;
  readonly frenchFrance$: Observable<any>;
  readonly frenchCanada$: Observable<any>;
  readonly czech$: Observable<any>;
  readonly portuguese$: Observable<any>;
  readonly dutch$: Observable<any>;
  readonly german$: Observable<any>;

  constructor(private apiService: AtlasApiService) {
    this.frenchFrance$ = this.apiService.getTranslationFile(Language.FRENCH_FRANCE).pipe(shareReplay(1));
    this.frenchCanada$ = this.apiService.getTranslationFile(Language.FRENCH_CANADA).pipe(shareReplay(1));
    this.czech$ = this.apiService.getTranslationFile(Language.CZECH).pipe(shareReplay(1));
    this.portuguese$ = this.apiService.getTranslationFile(Language.PORTUGUESE).pipe(shareReplay(1));
    this.english$ = this.apiService.getTranslationFile(Language.ENGLISH).pipe(shareReplay(1));
    this.dutch$ = this.apiService.getTranslationFile(Language.DUTCH).pipe(shareReplay(1));
    this.german$ = this.apiService.getTranslationFile(Language.GERMAN).pipe(shareReplay(1));
  }

  getTranslation(lang: Language): Observable<any> {
    switch (lang) {
      case Language.FRENCH:
      case Language.FRENCH_CANADA:
        return this.frenchCanada$;
      case Language.FRENCH_FRANCE:
        return this.frenchFrance$;
      case Language.CZECH:
        return this.czech$;
      case Language.PORTUGUESE:
        return this.portuguese$;
      case Language.DUTCH:
        return this.dutch$;
      case Language.GERMAN:
        return this.german$;
      default:
        return this.english$;
    }
  }
}
